module.exports = __webpack_public_path__ + "img/irl.c68ff961.svg";